import { render, staticRenderFns } from "./boci-protocol.vue?vue&type=template&id=9f95344c&scoped=true"
import script from "./boci-protocol.vue?vue&type=script&lang=js"
export * from "./boci-protocol.vue?vue&type=script&lang=js"
import style0 from "./boci-protocol.vue?vue&type=style&index=0&id=9f95344c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f95344c",
  null
  
)

export default component.exports